/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { InvitationResponse } from '../../models/invitation-response';

export interface InvitationControllerAccept$Params {
  identifier: string;
}

export function invitationControllerAccept(http: HttpClient, rootUrl: string, params: InvitationControllerAccept$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: InvitationResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, invitationControllerAccept.PATH, 'post');
  if (params) {
    rb.path('identifier', params.identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: InvitationResponse;
      }>;
    })
  );
}

invitationControllerAccept.PATH = '/invitation/{identifier}/accept';
